export default "__VITE_ASSET__LiJ$fPvG__"